import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { getDayOfWeekByNumber } from '@app/utils/date'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ReactNode } from 'react'

import type {
  MonitoringScheduleColumnsSchedule,
  MonitoringScheduleColumns,
  MonitoringScheduleDataSource
} from '../types'

const getColumnsOptions = (): Array<Column<MonitoringScheduleColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof MonitoringScheduleColumns>

  return columnKeys.map(key => {
    const column: Column<MonitoringScheduleColumns> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const monitoringStartRender = (_: unknown, record: MonitoringScheduleDataSource): ReactNode => {
  const { monitoringStartDayOfWeek, monitoringStartAtTime } = record

  const dayOfWeek = getDayOfWeekByNumber(monitoringStartDayOfWeek)
  const leftPart = dayOfWeek ? `${dayOfWeek}, ` : ''
  const rightPart = monitoringStartAtTime ?? ''

  return leftPart + rightPart
}

const getScheduleChildren = (): Array<Column<MonitoringScheduleColumnsSchedule>> => {
  return [
    {
      key: 'receivingDataDeadline',
      title: 'Получение данных',
      sorter: (a, b) => sorterDispatcher(a.receivingDataDeadlineDays, b.receivingDataDeadlineDays),
      children: [
        {
          key: 'receivingDataDeadlineDays',
          dataIndex: 'receivingDataDeadlineDays',
          title: '+дн'
        },
        {
          key: 'receivingDataDeadlineTime',
          dataIndex: 'receivingDataDeadlineTime',
          title: 'Время'
        }
      ]
    },
    {
      key: 'processingDataDeadline',
      title: 'Обработка данных',
      sorter: (a, b) => sorterDispatcher(a.processingDataDeadlineDays, b.processingDataDeadlineDays),
      children: [
        {
          key: 'processingDataDeadlineDays',
          dataIndex: 'processingDataDeadlineDays',
          title: '+дн'
        },
        {
          key: 'processingDataDeadlineTime',
          dataIndex: 'processingDataDeadlineTime',
          title: 'Время'
        }
      ]
    },
    {
      key: 'newDataDeadline',
      title: 'Выставление новой цены',
      sorter: (a, b) => sorterDispatcher(a.newDataDeadlineDays, b.newDataDeadlineDays),
      children: [
        {
          key: 'newDataDeadlineDays',
          dataIndex: 'newDataDeadlineDays',
          title: '+дн'
        },
        {
          key: 'newDataDeadlineTime',
          dataIndex: 'newDataDeadlineTime',
          title: 'Время'
        }
      ]
    }
  ]
}

export const getColumns = (): Array<Column<MonitoringScheduleDataSource>> =>
  [
    ...getColumnsFromMap<MonitoringScheduleColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    }),
    {
      key: 'monitoringSchedule',
      title: 'Расписание/Дедлайны',
      children: [
        {
          key: 'monitoringStartDayOfWeek',
          dataIndex: 'monitoringStartDayOfWeek',
          title: 'Старт',
          sorter: (a, b) => sorterDispatcher(a.monitoringStartDayOfWeek, b.monitoringStartDayOfWeek),
          render: monitoringStartRender
        },
        ...getScheduleChildren()
      ]
    }
  ] as Array<Column<MonitoringScheduleDataSource>>
